<template>
  <div class="c-record">
    <!-- filter -->
    <design-filter
      :agent-data="operator"
      :game-data="gameData"
      :project-data="projectData"
      :syncing="syncing"
      @on-set="model = true"
      @on-sync="syncData"
      @on-export="downData"
      @on-change="filterData"
      @on-search="searchFilterData"
      @on-custom-col="modalColumn = true"
    />

    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <design-table
          ref="designtable"
          :loading="loading"
          :data="tableList"
          :summary="summaries"
          :columns="tableCols"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-refresh="getData"
        />

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :sub-title="['基础数据']" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/design_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { getSysMember, adGames, getSysProject } from '@/api/common.model'
import { getAllUser, setAssessOperator, getDesignList, synReportDesignList } from '@/api/manage.model'
import DesignFilter from './components/design-filter.vue'
import DesignTable from './components/design-table.vue'
import CustomColumn from '@/components/converter/custom-column.vue'

export default {
  name: 'designList',
  mixins: [mixin],
  components: { DesignFilter, DesignTable, CustomColumn },
  computed: {
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('DesignDataCustomColumn', show)
      },
      deep: true
    }
  },
  methods: {
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize,
        keyWord: this.params && this.params.keyWord,
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getDesignList(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info, sum_data } = data
          if (isArray(list) && page_info && sum_data) {
            const { total_number } = page_info
            this.summaries = sum_data
            this.total = total_number || 0
            this.tableList = list
            this.$nextTick(() => {
              this.$refs.designtable && this.$refs.designtable.doLayout()
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      // const param = Object.assign(this.params, { sort, order })
      // this.params = JSON.parse(JSON.stringify(param))
      this.pageIndex = 1
      this.getData()
    },
    uploadAssessOperator() {
      getAllUser().then((data) => {
        this.saving = false
        if (isArray(data)) {
          this.operator = data.map((ret) => {
            return {
              id: ret.id,
              name: ret.name
            }
          })
          this.mult_operator = data.map((ret) => ret.opId)
          this.model = false
          this.getData()
        }
      })
    },
    syncData() {
      const params = { reportMonth: this.params.reportMonth }
      this.syncing = true
      synReportDesignList(params).then((data) => {
        this.syncing = false
        if (data) {
          this.$Message.success({
            duration: 5,
            content: '同步完成!'
          })
          this.getData()
        }
      })
    },
    asyncOk() {
      this.saving = true
      setAssessOperator({
        type: 2,
        opIds: this.mult_operator.join(',')
      }).then((data) => {
        if (data) this.uploadAssessOperator()
        else this.saving = false
      })
    },
    preLoadData() {
      Promise.all([getAllUser(), getSysMember(), adGames(), getSysProject()])
        .then((data) => {
          const [operaData, agentData, gameData, projectData] = data
          isArray(agentData) && (this.agentData = agentData)
          if (isArray(operaData)) {
            this.operator = operaData.map((ret) => {
              return {
                id: ret.id,
                name: ret.name
              }
            })
            this.mult_operator = operaData.map((ret) => ret.opId)
          }
          isArray(gameData) && (this.gameData = gameData)
          isArray(projectData) && (this.projectData = projectData)
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    downData() {
      let url = `${HOST_API}/api/ptom/designkpi/report/down`
      url += `?sessionid=${this.$store.state.token}`
      this.params.keyWord && (url += `&keyWord=${this.params.keyWord}`)
      this.params.reportMonth && (url += `&reportMonth=${this.params.reportMonth}`)
      this.params.designerId && (url += `&designerId=${this.params.designerId}`)
      this.params.gameId && (url += `&gameId=${this.params.gameId}`)
      this.params.imageType && (url += `&imageType=${this.params.imageType}`)
      this.params.projectGroupId && (url += `&projectGroupId=${this.params.projectGroupId}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      this.params.imageStyles && (url += `&imageStyles=${this.params.imageStyles}`)
      console.log(url)
      window.open(url)
    },
    setLocalPage(size) {
      setLocal('DESIGN_PAGESIZE', size)
    }
  },
  data() {
    return {
      tableHeight: 330,
      syncing: null, // 同步状态
      columns: [], // 表格字段
      summaries: {}, // 后台合计对象
      model: false, // 弹窗开关
      saving: false, // 设置状态
      agentData: [], // 所有人员
      gameData: [], // 所有游戏
      operator: [], // 考核人
      projectData: [], // 项目组
      mult_operator: [], // 多选考核人
      recordType: null // 报表默认
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('DESIGN_PAGESIZE')) || 20
    const shows = this.getCustomStorage('DesignDataCustomColumn')
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret)
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
